export default function Divider() {
  return <span className="border border-1 w-100 rounded-pill"></span>;
}
